module.exports = __webpack_public_path__ + "static/media/presentation_addon.53baad8c.jpg";